import { getAccessSnapshot } from "../context/AccessControl/accessSnapshot";

/**
 * ¿Puede esta persona ver este elemento del menú?
 *
 * WHY existe separado de `<Can>`: `<Can>` arrastra un vocabulario heredado
 * orientado a componentes ("user-modal:editProfile") que convive con el catálogo
 * real del backend. El menú ya NO habla ese idioma: cada elemento declara su
 * permiso del catálogo ("flowbuilder:ver"), así que aquí no hay heurística que
 * adivine de qué vocabulario es una clave. Una sola fuente, una sola decisión.
 *
 * WHY la misma función decide el elemento Y su grupo: antes el grupo se decidía
 * por `profile` y el elemento por `<Can>`. Cuando las dos discrepaban salía una
 * cabecera que abría sobre una lista vacía. Con una única función eso no puede
 * volver a ocurrir: si ningún elemento pasa, el grupo no se dibuja.
 */
export const puedeVerItemDeMenu = (item, usuario) => {
  // Sin candado: información sobre uno mismo o ayuda del producto (Mi equipo,
  // Ayuda). No pertenecen a ningún módulo del catálogo y nunca fueron
  // administrativos.
  if (!item || !item.permission) return true;

  const snapshot = getAccessSnapshot();

  // Camino normal: manda el rol. `can()` ya concede todo al ámbito plataforma.
  if (snapshot.loaded) return snapshot.can(item.permission);

  /**
   * Modo degradado: `/me/permissions` no contestó.
   *
   * La carga de permisos nunca puede impedir trabajar, así que se recurre a la
   * marca `fallback`, que reproduce EXACTAMENTE el reparto anterior
   * (`drawer-admin-items:view` → 'admin', `drawer-service-items:view` →
   * 'service'). Un panel sin backend de permisos se comporta como el de
   * siempre, ni más abierto ni más cerrado.
   */
  if (esElevado(usuario)) return true;
  return item.fallback !== "admin";
};

/** Administrador de empresa o superusuario de plataforma. */
export const esElevado = usuario =>
  usuario?.profile === "admin" ||
  usuario?.super === true ||
  usuario?.super === 1 ||
  String(usuario?.super) === "1";
